<template>
  <div :class="'resultView '">
    <div class="detail">
      <Alert show-icon type="warning" v-if="recordData.requirements">
        回拨要求
        <template slot="desc">{{recordData.requirements}}</template>
      </Alert>
      <Tabs>
        <Tab-pane label="呼入记录" name="calledLogs">
          <template v-if="records && records.length > 0">
            <template v-if="recordItem.subType == 'HL_MS'">
              <table class="recordInfoTable">
                <thead>
                  <tr>
                    <th style="text-align: center" width="60px">序号</th>
                    <th style="text-align: center" width="80px">状态</th>
                    <th>订单ID</th>
                    <th>流水号</th>
                    <th>呼入号码</th>
                    <th>拨打时间</th>
                    <th style="text-align: center" width="60px">等待时长</th>
                    <th>备注</th>
                  </tr>
                </thead>
                <tr :key="item.id" v-for="(item, index) in records">
                  <td style="text-align: center" width="60px">{{index +1}}</td>
                  <td style="text-align: center">{{item.statusLabel}}</td>
                  <td>{{item.orderId}}</td>
                  <td>{{item.serialNum}}</td>
                  <td>{{item.callPhone | desensitizedTelNum}}</td>
                  <td>{{item.callTime}}</td>
                  <td style="text-align: center" width="60px">{{item.waitTime}}</td>
                  <td>{{item.remark}}</td>
                </tr>
              </table>
            </template>
            <template v-else>
              <table class="recordInfoTable">
                <thead>
                  <tr>
                    <th style="text-align: center" width="60px">序号</th>
                    <th style="text-align: center" width="80px">状态</th>
                    <th>流水号</th>
                    <th>呼入号码</th>
                    <th>拨打时间</th>
                    <th style="text-align: center" width="60px">等待时长</th>
                  </tr>
                </thead>
                <tr :key="item.id" v-for="(item, index) in records">
                  <td style="text-align: center" width="60px">{{index +1}}</td>
                  <td style="text-align: center">{{item.recordStatusLabel}}</td>
                  <td>{{item.serialNum}}</td>
                  <td>{{item.caller | desensitizedTelNum}}</td>
                  <td>{{item.startTime}}</td>
                  <td style="text-align: center" width="60px">{{item.waitTime}}</td>
                </tr>
              </table>
            </template>
          </template>
        </Tab-pane>
        <Tab-pane label="回拨记录" name="calledRecord">
          <Table :columns="columnsCalled" :data="calledRecords" border size="small"></Table>
        </Tab-pane>
      </Tabs>
    </div>
    <water-mark :opacity="0.5"></water-mark>
    <Modal
      :title="'预览--'+ viewFileData.name"
      @on-cancel="()=>{this.showPreview= false}"
      fullscreen
      v-model="showPreview"
    >
      <filePreview :fileOption="viewFileData" v-if="showPreview"></filePreview>
    </Modal>
  </div>
</template>
<script> 
export default {
  name: 'followUpResult',
  props: {
    itemId: {
      required: true
    }
  },
  data () {
    return {
      fileUrl: '',
      recordData: {},
      recordItem: {},
      calledRecords: [],
      records: [],
      gaugingResult: {
        itemId: null,
        result: null,
        remark: '',
        satisfactionResult: null
      },
      gaugingResultValidate: {
        remark: [{ required: true, message: '请输入回拨记录', trigger: "blur" }],
        satisfactionResult: [{ required: true, message: '请选择回拨后满意度', trigger: 'change' }],
      },
      satisfactionResultOptions: [],
      fileList: [],
      fileOpts: {
        multiple: true,
        format: ['jpg', 'jpeg', 'png', 'doc', 'docx', 'pdf', 'xls', 'xlsx'],
        showUploadList: false,
        defauleFiles: [],
        data: {
          catalogName: "FollowUp"
        },
      },
      showPreview: false,
      viewFileData: {},
      columnsCalled: [
        { title: "序号", align: "center", type: "index", minWidth: 90, },
        { title: "拨打时间", align: "right", key: "callTime", tooltip: true, minWidth: 160, },
        { title: "接通时间", align: "right", key: "establishedTime", tooltip: true, minWidth: 160, },
        { title: "结束时间", align: "right", key: "releaseTime", tooltip: true, minWidth: 160, }
      ]
    }
  },
  computed: {
    type: function () {
      if (this.recordItem.status == 'todo' || this.recordItem.status == 'during') {
        return 'gauging'
      }
      return 'view'
    },
    isAdmin: function () {
      return this.$store.getters['userInfo/isAdmin'] || false
    },
    systemRoles: function () {
      return (this.$store.getters['userInfo/user'] || {}).systemRoles || []
    },
    hasOperationRole: function () {
      return (this.systemRoles || []).indexOf('OPERATION_MANAGER') >= 0 || (this.systemRoles || []).indexOf('OPERATION') >= 0
    },
    showControlslist: function () {
      return (this.hasOperationRole || this.isAdmin) ? 'nofullscreen' : 'nodownload'
    },
  },
  watch: {
    itemId: {
      deep: true,
      immediate: true,
      handler: function (val) {
        if (val) {
          this.getGauging()
        }
      }
    }
  },
  methods: {
    getBasePath: async function (fileId) {
      console.log('this.fileId', fileId)
      if (fileId) {
        let params = new this.$URLSearchParams()
        params.append("id", fileId)
        let data = await this.$axios.post(this.$apis.fileServerApi.getFileVisitedPath, params)
        this.fileUrl = data.result
      }

      // return data.result
    },

    uploadFile: function (data) {
      let that = this
      this.fileList = data
      if (this.fileList.length > 0) {
        this.fileList.forEach(function (obj) {
          obj['getFileType'] = that.$common.getFileType(obj.fileType)
        })
      }
    },
    handleRemove: function (file) {
      const infileList = this.$refs.uploadFile.fileList
      this.$refs.uploadFile.fileList.splice(infileList.indexOf(file), 1)
    },
    viewFile (item, index) {
      this.viewFileData = Object.assign({}, item)
      this.viewFileData.filePath = item.url
      this.showPreview = true
    },
    submitResult: function (type) {
      let that = this
      this.gaugingResult.type = type
      switch (type) {
        case 'staging':


          this.$Modal.confirm({
            title: '提醒',
            content: `<p>请确认是否${type == 'final' ? '提交' : '暂存'}本次回拨内容！</p>`,
            okText: type == 'final' ? '提交' : '暂存',
            onOk: () => {
              that.$Spin.show({
                render: (h) => {
                  return h('div', [
                    h('Icon', {
                      'class': 'demo-spin-icon-load',
                      props: {
                        type: 'ios-loading',
                        size: 18
                      }
                    }),
                    h('div', '正在提交，请稍候...')
                  ])
                }
              })
              this.gaugingResult.itemId = this.itemId
              that.$set(that.gaugingResult, 'files', that.fileList)
              that.$axios.post(this.$apis.callBackApi.gauging.gaugingResult, this.gaugingResult).then(res => {
                if (res.success) {
                  this.recordItem = res.result || {}
                  if (this.recordItem.fileId) {
                    this.getBasePath(this.recordItem.fileId)
                  }
                  that.$Message.success({
                    duration: 3,
                    content: '暂存成功'
                  })
                } else {
                  that.$Message.error({
                    duration: 3,
                    content: res.message
                  })
                }
              }).catch(function (err) {
                console.error("submitResult errpr", err)
                that.$Message.error('提交失败！')
              }).finally(() => {
                that.$Spin.hide()
              })
            }
          })
          break
        default:
          this.$refs["gaugingResult"].validate(valid => {
            if (valid) {
              this.$Modal.confirm({
                title: '提醒',
                content: `<p>请确认是否${type == 'final' ? '提交' : '暂存'}本次回拨内容！</p>`,
                okText: type == 'final' ? '提交' : '暂存',
                onOk: () => {
                  that.$Spin.show({
                    render: (h) => {
                      return h('div', [
                        h('Icon', {
                          'class': 'demo-spin-icon-load',
                          props: {
                            type: 'ios-loading',
                            size: 18
                          }
                        }),
                        h('div', '正在提交，请稍候...')
                      ])
                    }
                  })
                  this.gaugingResult.itemId = this.itemId
                  that.$set(that.gaugingResult, 'files', that.fileList)
                  that.$axios.post(this.$apis.callBackApi.gauging.gaugingResult, this.gaugingResult).then(res => {
                    if (res.success) {
                      this.recordItem = res.result || {}
                      if (this.recordItem.fileId) {
                        this.getBasePath(this.recordItem.fileId)
                      }
                      that.$Message.success({
                        duration: 3,
                        content: '回拨完成'
                      })
                    } else {
                      that.$Message.error({
                        duration: 3,
                        content: res.message
                      })
                    }
                  }).catch(function (err) {
                    console.error("submitResult errpr", err)
                    that.$Message.error('提交失败！')
                  }).finally(() => {
                    that.$Spin.hide()
                  })
                }
              })
            }
          })
          break
      }

    },
    getGauging: function () {
      let that = this
      let param = new this.$URLSearchParams()
      param.append('itemId', this.itemId)
      that.$axios.post(this.$apis.callBackApi.gauging.getGauging, param).then(res => {
        if (res.success) {
          this.recordData = res.result || {}
          this.calledRecords = (res.result || {}).calledRecords || []
          this.records = (res.result || {}).records || []
          this.recordItem = this.recordData.recordItem || {}
          this.gaugingResult.remark = this.recordItem.remark
          this.gaugingResult.satisfactionResult = this.recordItem.satisfactionResult
          if (this.recordItem.fileId) {
            this.getBasePath(this.recordItem.fileId)
          }

        } else {
          that.$Message.error({
            duration: 3,
            content: res.message
          })
        }
      }).catch(function (err) {
        console.error("getGauging errpr", err)
        that.$Message.error('获取回拨记录失败！')
      })
    },
    loadSatisfactionResults: async function () {
      this.satisfactionResultOptions = await this.$baseData.handleData(false, this.$apis.common.satisfactionResultOptions, null) || []
    },
  },
  beforeMount () {
    this.loadSatisfactionResults()
  }
}
</script>
<style lang="less" scoped>
.resultView {
  // height: 100%;
  position: relative;
  box-sizing: border-box;
  overflow-y: auto;

  .consultContent {
    // margin-right: 1rem;
    width: 100%;
    max-width: 100%;

    .selfPanel {
      border-radius: 4px;
      border: 1px solid #d7d7d7;
    }
  }

  .infos {
    display: flex;
    padding: 1rem;
    overflow-y: auto;
  }

  .detail {
    // background: #fff;
    padding: 1rem;
    overflow-y: auto;
    // box-shadow: 5px 4px 5px #ddd;
    // border-bottom: 1px dashed #ddd;
    // margin-bottom: 5px;
  }
}

.resultView.flex {
  overflow-y: hidden;
  display: flex;

  .infos,
  .detail {
    padding: 0;
    margin: 10px;
  }

  .consultContent {
    margin-right: 0;
  }
}

.resultView:not(.flex) {
  .detail {
    position: sticky;
    top: 0;
    z-index: 999;
    background: #fff;
    padding: 1rem;
    overflow-y: auto;
    // box-shadow: 5px 4px 5px #ddd;
    // border-bottom: 1px dashed #ddd;
    // margin-bottom: 5px;
  }
}

.sunflower-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  /* border: 1px solid transparent; */
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.sunflower-upload-list img {
  width: 100%;
  height: 100%;
}
.sunflower-upload-list .fileIcon {
  width: 100%;
  height: 100%;
}
.sunflower-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.sunflower-upload-list:hover .sunflower-upload-list-cover {
  display: block;
}
.sunflower-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.resultTable {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  .conclusion {
    background: #eee;
    text-align: center;
    font-weight: 600;
    font-size: 0.9rem;
  }

  td {
    border: 1px solid #dcdee2;
    padding: 2px 4px;
    min-height: 2.4rem;
    height: 2.4rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

  td.label {
    text-align: center;
    font-size: 0.85rem;
    background: #f8f8f9;
    width: 20%;
  }
}

.recordInfoTable {
  font-size: 0.8rem;
  border-collapse: collapse;
  // margin: 10px;
  background: transparent;
  width: 100%;
  table-layout: auto;

  td,
  th {
    padding: 2px;
    font-size: 0.75rem;
    border: 1px solid #e8eaec;
    background: #fdfdfd !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 32px;
  }
}
</style>